import { render } from "./InstructionApixDrivePage.vue?vue&type=template&id=650fe3a5&scoped=true"
import script from "./InstructionApixDrivePage.vue?vue&type=script&lang=js"
export * from "./InstructionApixDrivePage.vue?vue&type=script&lang=js"

import "./InstructionApixDrivePage.vue?vue&type=style&index=0&id=650fe3a5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-650fe3a5"]])

export default __exports__